


// gold chart
const getGold = async function (x, y) {
    const response = await fetch('https://goldapi.deuslab.com/?function=history&elements=au&key=pepe');
    const data = await response.json();
    const labels = Object.keys(data.data.au);
    const values = Object.values(data.data.au);
    return { labels, values };
}

const goldChart = async function () {
    const { labels, values } = await getGold();
    const ctx = document.getElementById('myChart');
    if(ctx==null) return;
    const xlabels = labels
    new Chart(ctx, {
        type: 'line',
        data: {
            labels: xlabels,
            datasets: [{

                label: 'ORO',
                data: values,
                borderColor: 'rgb(247, 148, 19)',
                tension: 0.3,
                borderWidth: 2,
                pointRadius: 1,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 6,



            }]
        },
        options: {
            plugins: {
                legend: {
                    onClick() { },
                    onHover: function (event, legendItem) {
                        if (!this.chart.legendHovering) {
                            this.chart.data.datasets[0].pointRadius = 3;
                            this.chart.data.datasets[0].pointBorderWidth = 3;
                            this.chart.update();
                            this.chart.legendHovering = true;
                        }
                    },
                    onLeave: function (event, legendItem) {
                        this.chart.data.datasets[0].pointRadius = 1;
                        this.chart.data.datasets[0].pointBorderWidth = 2;
                        this.chart.update();
                        this.chart.legendHovering = false;
                    },

                    position: 'right',
                    align: 'start',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'rectRounded',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        maxTicksLimit: 6
                    },
                    grid: {
                        display: false,

                        lineWidth: 5,
                        drawBorder: false,
                        drawTicks: false,

                    },

                },
                y: {
                    beginAtZero: true,
                    min: 1400,
                    ticks: {
                        stepSize: 100
                    },

                    border: {
                        display: false,
                    },

                }
            }
        }
    });


}
goldChart();





// plata graph 

const getPlata = async function (x, y) {
    const response = await fetch('https://goldapi.deuslab.com/?function=history&elements=ag&key=pepe');
    const data = await response.json();
    const labels = Object.keys(data.data.ag);
    const values = Object.values(data.data.ag);
    return { labels, values };
}

const plataChart = async function (a, b) {
    const { labels, values } = await getPlata();
    const plata = document.getElementById('PlataChart');
    if(plata==null) return;
    const platalabels = labels;
    new Chart(plata, {
        type: 'line',
        data: {
            labels: platalabels,
            datasets: [{

                label: 'Plata',
                data: values,
                borderColor: '#9a9a9a',
                tension: 0.3,
                borderWidth: 2,
                pointRadius: 1,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 5,


            }]
        },
        options: {
            plugins: {
                legend: {
                    onClick() { },
                    onHover: function (event, legendItem) {
                        if (!this.chart.legendHovering) {
                            this.chart.data.datasets[0].pointRadius = 3;
                            this.chart.data.datasets[0].pointBorderWidth = 3;
                            this.chart.update();
                            this.chart.legendHovering = true;
                        }
                    },
                    onLeave: function (event, legendItem) {
                        this.chart.data.datasets[0].pointRadius = 1;
                        this.chart.data.datasets[0].pointBorderWidth = 2;
                        this.chart.update();
                        this.chart.legendHovering = false;
                    },
                    position: 'right',
                    align: 'start',
                    backgroundColor: 'rgb(247, 148, 19)',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'rectRounded',
                        backgroundColor: 'rgb(247, 148, 19)',
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        maxTicksLimit: 6
                    },
                    grid: {
                        display: false,

                        lineWidth: 1,
                        drawBorder: false,
                        drawTicks: false,

                    },

                },
                y: {
                    beginAtZero: true,
                    min: 16,
                    ticks: {
                        stepSize: 2
                    },
                    border: {
                        display: false,
                    },

                }
            }
        }
    });


}

plataChart();





// Palladium  graph 

const getPalladium = async function (x, y) {
    const response = await fetch('https://goldapi.deuslab.com/?function=history&elements=pd&key=pepe');
    const data = await response.json();
    const labels = Object.keys(data.data.pd);
    const values = Object.values(data.data.pd);
    return { labels, values };
}

const PalladiumChart = async function (a, b) {
    const { labels, values } = await getPalladium();
    const palladium = document.getElementById('palladiumChart');
    if(palladium==null)return;
    const palladiumlabels = labels;
    new Chart(palladium, {
        type: 'line',
        data: {
            labels: palladiumlabels,
            datasets: [{

                label: 'palladium',
                data: values,
                borderColor: '#9a9a9a',
                tension: 0.3,
                borderWidth: 2,
                pointRadius: 1,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 5,


            }]
        },
        options: {
            plugins: {
                legend: {
                    onClick() { },
                    onHover: function (event, legendItem) {
                        if (!this.chart.legendHovering) {
                            this.chart.data.datasets[0].pointRadius = 3;
                            this.chart.data.datasets[0].pointBorderWidth = 3;
                            this.chart.update();
                            this.chart.legendHovering = true;
                        }
                    },
                    onLeave: function (event, legendItem) {
                        this.chart.data.datasets[0].pointRadius = 1;
                        this.chart.data.datasets[0].pointBorderWidth = 2;
                        this.chart.update();
                        this.chart.legendHovering = false;
                    },
                    position: 'right',
                    align: 'start',
                    backgroundColor: 'rgb(247, 148, 19)',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'rectRounded',
                        backgroundColor: 'rgb(247, 148, 19)',
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        maxTicksLimit: 6
                    },
                    grid: {
                        display: false,

                        lineWidth: 1,
                        drawBorder: false,
                        drawTicks: false,

                    },

                },
                y: {
                    beginAtZero: true,
                    min: 16,
                    ticks: {
                        stepSize: 2
                    },
                    border: {
                        display: false,
                    },

                }
            }
        }
    });


}

PalladiumChart();


// platino chart

const myfunction = async function () {
    const response = await fetch('https://goldapi.deuslab.com/?function=history&elements=pt&key=pepe');
    const data = await response.json();
    const labels = Object.keys(data.data.pt);
    const values = Object.values(data.data.pt);
    return { labels, values };
}

const start = async function () {
    const { labels, values } = await myfunction();

    const platinoChart = document.getElementById('platinoChart');
     if(platinoChart!=null){
       new Chart(platinoChart, {
        type: 'line',
        data: {
            labels: labels,
            datasets: [{
                label: 'Platino',
                data: values,
                borderColor: '#9a9a9a',
                borderWidth: 2,
                tension: 0.3,
                pointRadius: 1,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 5,
            }]
        },
        options: {
            // maintainAspectRatio:false,
            plugins: {
                legend: {
                    onClick() { },
                    onHover: function (event, legendItem) {
                        if (!this.chart.legendHovering) {
                            this.chart.data.datasets[0].pointRadius = 3;
                            this.chart.data.datasets[0].pointBorderWidth = 3;
                            this.chart.update();
                            this.chart.legendHovering = true;
                        }
                    },
                    onLeave: function (event, legendItem) {
                        this.chart.data.datasets[0].pointRadius = 1;
                        this.chart.data.datasets[0].pointBorderWidth = 2;
                        this.chart.update();
                        this.chart.legendHovering = false;
                    },
                    position: 'right',
                    align: 'start',
                    backgroundColor: 'rgb(247, 148, 19)',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'rectRounded',
                        backgroundColor: 'rgb(247, 148, 19)',
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        maxTicksLimit: 6
                    },
                    grid: {
                        display: false,
                        lineWidth: 1,
                        drawBorder: false,
                        drawTicks: false,
                    }
                },
                y: {
                    beginAtZero: true,
                    min: 800,
                    ticks: {
                        stepSize: 100
                    },
                    border: {
                        display: false,
                    }
                }
            }
        }
    });
     }
    
}

start();

//  gold silver and platino  price
const getPlatinumPrice = async function () {
    const response = await fetch('https://goldapi.deuslab.com/?function=current&elements=au,ag,pt&key=pepe');
    const data = await response.json();
    return data.data
}
const showPrice = async function () {
    const { pt, ag, au } = await getPlatinumPrice()
    const ptprice = pt.kilo_price
    const res = parseFloat(ptprice).toFixed(2)

  
  // Gold price 
    const gold = document.getElementById('goldPrice');
    // const tabgold = document.getElementById('setPriceTab');
   if(gold) 
     gold.textContent = `US$${au.kilo_price}`;
    // tabgold.textContent = 'US' + auKiloPrice;

    const ouncePrice = document.getElementById('goldOunce');
    // const tabOunce = document.getElementById('setOuncePrice');
  if(ouncePrice)
      ouncePrice.textContent = `US$${au.ounce_price}`;
    // tabOunce.textContent = `USD$${au.ounce_price}`;

    const gramPrice = document.getElementById('goldGram');
    // const tabGram = document.getElementById('setGramPrice');
  if(gramPrice)
    gramPrice.textContent = `US$${au.grams_price}`;
    // tabGram.textContent = `USD$${au.grams_price}`;



    const OROKilo = document.getElementById('OROKilo');
   if(OROKilo) 
     OROKilo.textContent = `US$${au.kilo_price}`;

    const OROOunce = document.getElementById('OROOunce');
  if(OROOunce)
      OROOunce.textContent = `US$${au.ounce_price}`;

    const OROGram = document.getElementById('OROGram');
  if(OROGram)
    OROGram.textContent = `US$${au.grams_price}`;


  const GOLDKilo = document.getElementById('GOLDKilo');
   if(GOLDKilo) 
     GOLDKilo.textContent = `US$${au.kilo_price}`;

    const GOLDOunce = document.getElementById('GOLDOunce');
  if(GOLDOunce)
      GOLDOunce.textContent = `US$${au.ounce_price}`;

    const GOLDGram = document.getElementById('GOLDGram');
  if(GOLDGram)
    GOLDGram.textContent = `US$${au.grams_price}`;

    // silver price 
    const silverPrice = document.getElementById('silverKilo');
    const silverPriceTab = document.getElementById('setPriceTabSilver');
  if(silverPrice)
    silverPrice.textContent = `US$${ag.kilo_price}`;
  if(silverPriceTab)
    silverPriceTab.textContent = `USD ${ag.kilo_price}`;
    
    const silverOuncePrice = document.getElementById('silverOunce');
    const silverOuncePriceTab = document.getElementById('setOuncePriceSilver');
  if(silverOuncePrice)
    silverOuncePrice.textContent = `US$${ag.ounce_price}`;
  if(silverOuncePriceTab)
    silverOuncePriceTab.textContent = `USD ${ag.ounce_price}`;

    const silverGramPrice = document.getElementById('silverGram');
    const silverGramPriceTab = document.getElementById('setGramPriceSilver');
  if(silverGramPrice)
    silverGramPrice.textContent = `US$${ag.grams_price}`;
  if(silverGramPriceTab)
    silverGramPriceTab.textContent = `USD ${ag.grams_price}`;





   // silver price 
    const PLATAKilo = document.getElementById('PLATAKilo');
  if(PLATAKilo)
    PLATAKilo.textContent = `US$${ag.kilo_price}`;
 
    
    const PLATAOunce = document.getElementById('PLATAOunce');
  if(PLATAOunce)
    PLATAOunce.textContent = `US$${ag.ounce_price}`;
 

    const PLATAGram = document.getElementById('PLATAGram');
  if(PLATAGram)
    PLATAGram.textContent = `US$${ag.grams_price}`;
  
    const SILVERKilo = document.getElementById('SILVERKilo');
  if(SILVERKilo)
    SILVERKilo.textContent = `US$${ag.kilo_price}`;
 
    
    const SILVEROunce = document.getElementById('SILVEROunce');
  if(SILVEROunce)
    SILVEROunce.textContent = `US$${ag.ounce_price}`;
 

    const SILVERGram = document.getElementById('SILVERGram');
  if(SILVERGram)
    SILVERGram.textContent = `US$${ag.grams_price}`;



  

  
    // platinum price
    const platinumPriceElement = document.getElementById('platinoKilo');
  if(platinumPriceElement)
    platinumPriceElement.textContent = `US$${ptprice}`;
    const ptOuncePrice = document.getElementById('ouncePrice');
  if(ptOuncePrice)
    ptOuncePrice.textContent = `US$${pt.ounce_price}`;
    const ptgramPrice = document.getElementById('gramPrice');
  if(ptgramPrice)
    ptgramPrice.textContent = `US$${pt.grams_price}`;


   const PlatinoKilo = document.getElementById('PlatinoKilo');
  if(PlatinoKilo)
    PlatinoKilo.textContent = `US$${ptprice}`;
    const PlatinoOunce = document.getElementById('PlatinoOunce');
  if(PlatinoOunce)
    PlatinoOunce.textContent = `US$${pt.ounce_price}`;
    const PlatinoGram = document.getElementById('PlatinoGram');
  if(PlatinoGram)
    PlatinoGram.textContent = `US$${pt.grams_price}`;
  
   const PLATINUMKilo = document.getElementById('PLATINUMKilo');
  if(PLATINUMKilo)
    PLATINUMKilo.textContent = `US$${ptprice}`;
  
    const PLATINUMOunce = document.getElementById('PLATINUMOunce');
  if(PLATINUMOunce)
    PLATINUMOunce.textContent = `US$${pt.ounce_price}`;
  
    const PLATINUMGram = document.getElementById('PLATINUMGram');
  if(PLATINUMGram)
    PLATINUMGram.textContent = `US$${pt.grams_price}`;
  let secthead= document.querySelector('.shopify-section--tabs .section-header')
  if(secthead!=null)
    secthead.classList.remove('d-none');
}
showPrice();


// document.addEventListener('DOMContentLoaded', function () {
//     const links = document.querySelectorAll('a[href^="#"]');

//     for (const link of links) {
//         link.addEventListener('click', function (e) {
//             e.preventDefault();

//             const targetId = this.getAttribute('href').substring(1);
//             const targetSection = document.getElementById(targetId);

//             if (targetSection) {
//                 targetSection.scrollIntoView({
//                     behavior: 'smooth'
//                 });
//             }
//         });
//     }
// });

// document.addEventListener('scroll', function () {
//     const navbar = document.getElementById('navigation');
//     const scrollPosition = window.scrollY;

//     if (scrollPosition > 200) {
//         navbar.classList.add('sticky');
//     } else {
//         navbar.classList.remove('sticky');
//     }
// });

// making tab

let previousTabButton = null;

function openTab(tabName, tabButton) {

  let tabContent = document.getElementsByClassName("tab-content");
  for (let i = 0; i < tabContent.length; i++) {
    tabContent[i].style.display = "none";
  }

  let tabs = document.getElementsByClassName("tab");
  for (let i = 0; i < tabs.length; i++) {
    tabs[i].classList.remove("active");
  }


  document.getElementById(tabName).style.display = "block";


  tabButton.classList.add("active");


  if (previousTabButton !== null) {
    previousTabButton.classList.remove("active");
  }

  previousTabButton = tabButton;
}

  


